import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { SubscriptionRequest } from '@model/TradingPlatformsDto'

interface Props {
  subscriptionRequest?: SubscriptionRequest
  onConfirm: (subscriptionRequest?: SubscriptionRequest) => void
}

export const UnsubscribeAttentionModal: BaseModalType<Props> = (props) => {
  const { subscriptionRequest, onConfirm, close } = props
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Subscriptions.Attention')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{t('Subscriptions.unsubscribe attention position 1')}</Modal.Body.Text>
        <Modal.Body.Text>{t('Subscriptions.unsubscribe attention position 2')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>
          {t('Subscriptions.Keep subscription')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={() => onConfirm(subscriptionRequest)}>
          {t('Subscriptions.Yes, unsubscribe')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
